// @flow
import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import type { SidePanel } from 'esm-web-pro/redux/side-panel/reducer';
import { getSidePanel } from 'esm-web-pro/redux/side-panel';
import { bindActionCreators } from 'redux';
import * as sidePanelActions from 'esm-web-pro/redux/side-panel/actions';
import { Box, Button } from 'grommet';
import { History, Match } from 'react-router-dom';
import { withLeaflet } from 'react-leaflet';
import type { LeafletContext } from 'react-leaflet/src';
import MeasureIcon from 'esm-web-pro/components/maps/measure/MeasureIcon';
import ReactTooltip from 'react-tooltip';
import { useIntl } from 'react-intl';
import LabelText from 'esm-web-pro/components/layout/sidePanel/LabelText';


type SidePanelStoreProps = {
    sidePanel: ?SidePanel,
}

type Props = {
    ...$Exact<SidePanelStoreProps>,

    history: History,
    match: Match,
    leaflet: LeafletContext,
}

const mapStateToProps = (state, ownProps) => ({
    sidePanel: (() => getSidePanel(state, ownProps.id))(),
});

const mapDispatchToProps = (dispatch) => (
    bindActionCreators(sidePanelActions, dispatch)
);

const MeasureControl = (props: Props) => {
    const {
        sidePanel, history, match, leaflet: { map: { grouping } },
    } = props;

    const handleOpen = (e) => {
        e.stopPropagation();
        history.push(`${match.url.split('/layer')[0]}/measure/`);
    };
    const { formatMessage } = useIntl();

    return (!sidePanel && !grouping) ? (
        <Box pad={{ bottom: 'xsmall' }}>
            <Button
                plain
                icon={<MeasureIcon width="30px" />}
                onClick={handleOpen}
                data-tip
                data-for="map-measure-control-tooltip"
            />
            <ReactTooltip
                id="map-measure-control-tooltip"
                effect="solid"
                place="left"
                className="react-tooltip"
            >
                <LabelText>{formatMessage({ id: 'map-measure-control', defaultMessage: 'Measure control' })}</LabelText>
            </ReactTooltip>
        </Box>
    ) : null;
};


export default withLeaflet(withRouter(connect(mapStateToProps, mapDispatchToProps)(MeasureControl)));
